import { render, staticRenderFns } from "./SimeparMobile.vue?vue&type=template&id=30057d90&scoped=true"
import script from "./SimeparMobile.vue?vue&type=script&lang=js"
export * from "./SimeparMobile.vue?vue&type=script&lang=js"
import style0 from "./SimeparMobile.vue?vue&type=style&index=0&id=30057d90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30057d90",
  null
  
)

export default component.exports